import { apiClient } from "../apiClient";

export const lopApi = {
SelectLop: () => apiClient.get("user/lops"),
SelectHe: () => apiClient.get("user/he"),
SelectKhoa: () => apiClient.get("user/khoa"),
SelectKhoaHoc: () => apiClient.get("user/khoahoc"),
SelectNganh: () => apiClient.get("user/nganh"),
SelectChuyenNganh: () => apiClient.get("user/chuyenganh"),
SelectKhoaByHe: (id_he: number) => apiClient.get(`user/khoa/${id_he}`),
SelectKhoaHocByHeKhoa: (id_he: number, id_khoa: number) => apiClient.get(`user/he/${id_he}/khoa/${id_khoa}/khoa-hoc`),
SelectNganhByHeKhoaKhoaHoc: (id_he: number, id_khoa: number, khoa_hoc: number) => apiClient.get(`user/he/${id_he}/khoa/${id_khoa}/khoa-hoc/${khoa_hoc}/nganh`),
SelectChuyenNganhByHeKhoaKhoaHocNganh: (id_he: number, id_khoa: number, khoa_hoc: number, id_nganh: number) => apiClient.get(`user/he/${id_he}/khoa/${id_khoa}/khoa-hoc/${khoa_hoc}/nganh/${id_nganh}/chuyen-nganh`),
}   